<template>
    <navigateable-tab>
        <template v-slot:default="{ tabId }">
            <question-tab :tabId="tabId" />
        </template>
    </navigateable-tab>
</template>

<script>
    import NavigateableTab from "../NavigateableTab";
    import QuestionTab from './QuestionTab';
    
    export default {
        name: "NavigateableQuestionTab",
        components: {
            NavigateableTab,
            QuestionTab
        }
    }
</script>
